/* octipa: gaveta do carrinho. Abre no icone do carrinho e em todo ATC (form /cart/add ou evento
   cl:cart:open), renderiza de /cart.js, aplica sozinha o codigo de desconto do kit (window.clBundleCodes:
   handle -> [[qtd, codigo]]) + o codigo digitado pelo cliente, e vende o upsell com variante. */
(function(){
  if (window.__clCart) return; window.__clCart = true;
  var D, OV, LIST, TOTAL, DISCS, busy = false;
  var TICKS = ['Livraison suivie et discrète', 'Échanges 100% Gratuits', 'Livraison Suivie (4 à 7 jours ouvrés)'];
  function money(c){
    var f = window.clMoneyFormat || '{{amount}}';
    function fmt(n, dec, th, ds){ var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s[0] + (s[1] ? ds + s[1] : ''); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_with_comma_separator') return fmt(c, 2, '.', ',');
      if (k === 'amount_no_decimals') return fmt(c, 0, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(c, 0, '.', ',');
      return fmt(c, 2, ',', '.'); });
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(m){
    return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[m]; }); }
  function img(u){ return u ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=160' : ''; }
  var TRASH = '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zm2.9 0a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z"/></svg>';
  function row(it){
    var opts = (it.options_with_values || []).filter(function(o){ return o.value && o.value !== 'Default Title'; })
      .map(function(o){ return esc(o.value); }).join(', ');
    var unitCmp = it.original_price > it.final_price ? it.original_price : (it.compare_at_price || 0);
    var lineCmp = it.original_line_price > it.final_line_price ? it.original_line_price : 0;
    return '<div class="clc-item" data-key="' + esc(it.key) + '">'
      + '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>'
      + '<div class="clc-info"><a class="clc-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>'
      + '<div class="clc-unit">' + (unitCmp > it.final_price ? '<s>' + money(unitCmp) + '</s>' : '') + money(it.final_price) + '</div>'
      + (opts ? '<div class="clc-var">' + opts + '</div>' : '')
      + '<div class="clc-ctl"><div class="clc-qty"><button type="button" data-clc-qty="' + (it.quantity - 1) + '" aria-label="Réduire la quantité">&minus;</button>'
      + '<span>' + it.quantity + '</span><button type="button" data-clc-qty="' + (it.quantity + 1) + '" aria-label="Augmenter la quantité">+</button></div>'
      + '<button type="button" class="clc-remove" data-clc-qty="0" aria-label="Supprimer">' + TRASH + '</button></div></div>'
      + '<div class="clc-line">' + (lineCmp ? '<s>' + money(lineCmp) + '</s>' : '') + money(it.final_line_price) + '</div></div>';
  }
  function render(cart){
    if (!D) return;
    LIST.innerHTML = (cart.items || []).map(row).join('');
    var tot = money(cart.total_price || 0);
    TOTAL.innerHTML = (cart.original_total_price > cart.total_price ? '<s>' + money(cart.original_total_price) + '</s>' : '') + tot;
    var d = {};
    (cart.items || []).forEach(function(it){ (it.line_level_discount_allocations || []).forEach(function(a){
      var t = (a.discount_application && a.discount_application.title) || 'Remise'; d[t] = (d[t] || 0) + a.amount; }); });
    (cart.cart_level_discount_applications || []).forEach(function(a){ d[a.title] = (d[a.title] || 0) + a.total_allocated_amount; });
    DISCS.innerHTML = Object.keys(d).map(function(k){ return '<div class="clc-disc"><span>' + esc(k.replace(/-/g, ' ')) + '</span><span>-' + money(d[k]) + '</span></div>'; }).join('');
    D.classList.toggle('is-empty', !(cart.item_count > 0));
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], .cart-count-bubble span:first-child, [data-cart-count]').forEach(function(e){ e.textContent = cart.item_count; });
    /* horizon: bolha do icone de carrinho do header */
    var n = cart.item_count || 0;
    document.querySelectorAll('cart-icon').forEach(function(ci){
      var cnt = ci.querySelector('.cart-bubble__text-count'), bub = ci.querySelector('.cart-bubble');
      if (cnt) { cnt.textContent = n < 100 ? String(n) : ''; cnt.classList.toggle('hidden', n === 0); }
      if (bub) bub.classList.toggle('visually-hidden', n === 0);
      ci.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    });
  }
  /* codigos: maior faixa de kit atingida por produto + o codigo digitado */
  function wantedCodes(cart){
    var map = window.clBundleCodes || {}, qty = {}, out = [];
    (cart.items || []).forEach(function(it){ qty[it.handle] = (qty[it.handle] || 0) + it.quantity; });
    Object.keys(qty).forEach(function(h){
      var best = null; (map[h] || []).forEach(function(t){ if (qty[h] >= t[0]) best = t[1]; });
      if (best) out.push(best);
    });
    var manual = ''; try { manual = sessionStorage.getItem('clc-code') || ''; } catch (e) {}
    if (manual) out.push(manual);
    return out;
  }
  function syncCodes(cart){
    var want = wantedCodes(cart).sort().join(',');
    var have = (cart.discount_codes || []).map(function(c){ return c.code; }).sort().join(',').toUpperCase();
    if (want.toUpperCase() === have) return Promise.resolve(cart);
    return fetch('/cart/update.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({discount: want})}).then(function(r){ return r.json(); }).catch(function(){ return cart; });
  }
  function refresh(){
    return fetch('/cart.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); })
      .then(syncCodes).then(function(c){ render(c); return c; }).catch(function(){});
  }
  function open(){ D.classList.add('is-open'); D.setAttribute('aria-hidden', 'false'); OV.classList.add('is-open');
    document.body.classList.add('clc-open'); refresh(); }
  function close(){ D.classList.remove('is-open'); D.setAttribute('aria-hidden', 'true'); OV.classList.remove('is-open');
    document.body.classList.remove('clc-open'); }
  function post(url, body){
    D.classList.add('is-loading');
    return fetch(url, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)})
      .then(function(r){ return r.json(); }).then(function(){ D.classList.remove('is-loading'); return refresh(); })
      .catch(function(){ D.classList.remove('is-loading'); });
  }
  function upVariant(card){
    var V = []; try { V = JSON.parse(card.querySelector('[data-clc-variants]').textContent); } catch (e) {}
    var vals = [].map.call(card.querySelectorAll('select[data-clc-opt]'), function(s){ return s.value; });
    return V.filter(function(v){ return vals.every(function(x, i){ return v.options[i] === x; }); })[0] || V.filter(function(v){ return v.available; })[0] || V[0];
  }
  function init(){
    D = document.getElementById('ClCart'); OV = document.getElementById('ClCartOverlay');
    if (!D) return;
    LIST = D.querySelector('[data-clc-items]'); TOTAL = D.querySelector('[data-clc-total]'); DISCS = D.querySelector('[data-clc-discs]');
    document.addEventListener('click', function(e){
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('[data-clc-close]')) { e.preventDefault(); close(); return; }
      var q = t.closest('[data-clc-qty]');
      if (q && D.contains(q)) { e.preventDefault(); post('/cart/change.js', {id: q.closest('.clc-item').getAttribute('data-key'), quantity: Math.max(0, +q.getAttribute('data-clc-qty'))}); return; }
      var a = t.closest('[data-clc-upadd]');
      if (a && D.contains(a)) { e.preventDefault(); var v = upVariant(a.closest('[data-clc-card]')); if (v) post('/cart/add.js', {items: [{id: v.id, quantity: 1}]}); return; }
      var nv = t.closest('[data-clc-upnav]');
      if (nv && D.contains(nv)) { var tr = nv.parentNode.querySelector('[data-clc-uptrack]'); tr.scrollBy({left: +nv.getAttribute('data-clc-upnav') * tr.clientWidth, behavior: 'smooth'}); return; }
      if (t.closest('[data-clc-checkout]')) { e.preventDefault(); window.location.href = '/checkout'; return; }
      var opener = t.closest('#cart-icon-bubble, cart-icon, [aria-controls="cart-drawer"], a.action__cart, a[href="/cart"], a[href$="/cart"], [data-cl-cart-open]');
      if (opener && !D.contains(opener)) { e.preventDefault(); e.stopPropagation(); open(); }
    }, true);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    document.addEventListener('submit', function(e){
      var f = e.target;
      if (!(f instanceof HTMLFormElement) || (f.getAttribute('action') || '').indexOf('/cart/add') === -1 || f.hasAttribute('data-cl-bundle')) return;
      e.preventDefault(); e.stopPropagation();
      var btn = f.querySelector('[type="submit"], button[name="add"]'); if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Accept': 'application/json'}, body: new FormData(f)})
        .then(function(r){ if (!r.ok) throw r; return r.json(); })
        .then(function(){ if (btn) btn.removeAttribute('aria-busy'); open(); })
        .catch(function(){ if (btn) btn.removeAttribute('aria-busy'); open(); });
    }, true);
    var cf = D.querySelector('[data-clc-codeform]');
    if (cf) cf.addEventListener('submit', function(e){
      e.preventDefault();
      var code = (cf.code.value || '').trim().toUpperCase(), msg = D.querySelector('[data-clc-codemsg]');
      try { if (code) sessionStorage.setItem('clc-code', code); else sessionStorage.removeItem('clc-code'); } catch (x) {}
      refresh().then(function(c){
        var ok = c && (c.discount_codes || []).some(function(d){ return d.code.toUpperCase() === code && d.applicable; });
        if (msg) msg.textContent = code && !ok ? 'Ce code n’est pas applicable à votre panier.' : '';
      });
    });
    document.addEventListener('cl:cart:open', open);
    /* faixa de garantias: gira a cada 3s */
    var tk = D.querySelector('[data-clc-tick]'), dots = D.querySelectorAll('[data-clc-ticker] .dots i'), ti = 1;
    setInterval(function(){ ti = (ti + 1) % TICKS.length; if (tk) tk.textContent = TICKS[ti];
      dots.forEach(function(d, j){ d.classList.toggle('on', j === ti); }); }, 3000);
    refresh();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
